import {Card} from 'antd';
import {FormInstance} from 'antd/es/form';
import React from 'react';

import {IFieldMeta} from 'entities/metadata';
import {IFormEntityData} from 'modules/data/data-types';

import {Field} from '../../field/field';

import './field-block.less';

export interface IFieldBlockProps {
    label?: string;
    fields?: IFieldMeta[];
    formData?: IFormEntityData;
    form?: FormInstance;
    disabled?: boolean;
    width?: string;
}

export const FieldBlock = ({
    label, fields, form, formData, disabled, width = '920px',
}: IFieldBlockProps) => (
    <Card
        className="field-block"
        title={label}
        style={{width}}
    >
        {
            fields?.map(fieldMeta => (
                <Field
                    formData={formData}
                    key={fieldMeta.key}
                    fieldMeta={{...fieldMeta, isDisabled: disabled || fieldMeta.isDisabled}}
                    form={form}
                />
            ))
        }
    </Card>
);
